import moment from "moment";
import { useEffect, useState } from "react";
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Spinner,
} from "reactstrap";
// import PickDateRange from "views/auth/PickDateRange";
import { addDays } from "date-fns";
import { updateCatalog } from "store/actions/catalogAction";
import { useDispatch, useSelector } from "react-redux";
import PickDateRange from "components/shared/PickDateRange";

function EditCatalogModal({ editModal, editToggle, editData, id }) {
  const dispatch = useDispatch();
  const { updateLoading, catalogs } = useSelector((state) => state.catalog);

  const [formData, setFormData] = useState({
    category: "",
    startTime: "",
    endTime: "",
    availability: "",
  });

  const [error, setError] = useState({});
  const [datestate, setDateState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));

    if (name === "category") {
      const categoryExists = catalogs.some(
        (c) =>
          c.category === value &&
          c.restaurantID === editData?.restaurantID &&
          c.id !== id
      );
      setError({
        ...error,
        category: categoryExists ? "This category already exists!" : "",
      });
    }
  };

  const handleCatalogSubmit = (e) => {
    e.preventDefault();
    const catalogData = {
      ...formData,
      restaurantID: editData?.restaurantID,
      createdAt: editData?.createdAt,
    };

    if (formData.availability === "available every day") {
      dispatch(
        updateCatalog(id, catalogData, () => {
          editToggle();
        })
      );
    } else {
      const updatedData = {
        ...catalogData,
        availabilityDate: {
          startDate: datestate[0].startDate,
          endDate: datestate[0].endDate,
        },
      };
      dispatch(
        updateCatalog(id, updatedData, () => {
          editToggle();
        })
      );
    }
  };

  const resetFormData = () => {
    setFormData({
      category: editData?.category || "",
      startTime: editData?.startTime || "",
      endTime: editData?.endTime || "",
      availability: editData?.availability || "",
    });
    setDateState([
      {
        startDate: editData?.availabilityDate?.startDate?.seconds
          ? moment.unix(editData.availabilityDate.startDate.seconds).toDate()
          : new Date(),

        endDate: editData?.availabilityDate?.endDate?.seconds
          ? moment.unix(editData.availabilityDate.endDate.seconds).toDate()
          : addDays(new Date(), 7),

        key: "selection",
      },
    ]);
  };

  const handleEditToggle = () => {
    resetFormData();
    editToggle();
  };

  const isDataValid =
    formData.category &&
    formData.startTime &&
    formData.endTime &&
    formData.availability &&
    (formData.availability !== "available specific day" ||
      (datestate[0]?.startDate && datestate[0]?.endDate)) &&
    !error.category;

  useEffect(() => {
    if (editData) {
      resetFormData();
    }
  }, [editData]);

  return (
    <div>
      <Modal isOpen={editModal}>
        <ModalHeader toggle={handleEditToggle}>
          Update Catalog Details
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleCatalogSubmit}>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="category">Categories</Label>
                  <Input
                    type="select"
                    id="exampleCustomSelect"
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Select Categories
                    </option>
                    <option value="breakfast">Breakfast</option>
                    <option value="dinner">Dinner</option>
                    <option value="lunch">Lunch</option>
                  </Input>
                  {error?.category && (
                    <p className="text-sm text-danger">{error?.category}</p>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="start-time">Start Time</Label>
                  <Input
                    type="time"
                    name="startTime"
                    id="date-inp"
                    placeholder="Start time"
                    value={formData.startTime}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>

              <Col>
                <FormGroup>
                  <Label for="end-time">End Time</Label>
                  <Input
                    type="time"
                    name="endTime"
                    id="date-inp"
                    placeholder="End time"
                    value={formData.endTime}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label for="availability">Availability</Label>
              <Input
                type="select"
                name="availability"
                placeholder="Availability"
                value={formData.availability}
                onChange={handleInputChange}
              >
                <option value="">Please select</option>
                <option value="available every day">Available Every Day</option>
                <option value="available specific day">
                  Available Specific Day
                </option>
              </Input>
            </FormGroup>

            {formData.availability === "available specific day" && (
              <Row>
                <Col className="mb-3 catalog__picker">
                  <PickDateRange
                    setDateState={setDateState}
                    datestate={datestate}
                    disablePast={true}
                  />
                </Col>
              </Row>
            )}

            <div className="d-flex justify-content-end">
              <Button color="primary" disabled={updateLoading || !isDataValid}>
                {updateLoading ? <Spinner size="sm" /> : "Update"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default EditCatalogModal;
